import React from 'react';
import './AlarmNotificationBanner.css';
import type { Alarm } from '../services/alarmService';
import { getLocale, useI18n } from '../i18n';

function formatTime(ts: string | undefined | null): string {
  if (!ts) return '';
  return new Date(ts).toLocaleTimeString(getLocale(), { hour: '2-digit', minute: '2-digit' });
}

interface Props {
  newAlarms: Alarm[];
  activeAlarms: Alarm[];
  onDismiss: (alarmId: string) => void;
  onAcknowledge: (alarmId: string) => void;
  onGoToAlarms: () => void;
}

export default function AlarmNotificationBanner({
  newAlarms,
  activeAlarms,
  onDismiss,
  onAcknowledge,
  onGoToAlarms,
}: Props) {
  const { t } = useI18n();

  if (!newAlarms || newAlarms.length === 0) return null;

  return (
    <div className="alarm-banner">
      {newAlarms.map((alarm) => {
        const enriched = activeAlarms.find((activeAlarm) => activeAlarm.id === alarm.id);
        const guardName = enriched?.profiles?.full_name ?? t('A guard');
        const siteName = enriched?.sites?.name ?? '';
        const title = alarm.title ?? enriched?.title ?? t('Alarm Triggered');
        const message = alarm.message ?? enriched?.message ?? '';

        return (
          <div key={alarm.id} className="alarm-banner__item">
            <div className="alarm-banner__pulse-ring" />
            <div className="alarm-banner__icon" />
            <div className="alarm-banner__content">
              <div className="alarm-banner__title">{title}</div>
              <div className="alarm-banner__detail">
                {guardName}
                {siteName ? ` / ${siteName}` : ''}
              </div>
              {message && <div className="alarm-banner__message">{message}</div>}
              <div className="alarm-banner__time">{formatTime(alarm.triggered_at)}</div>
            </div>
            <div className="alarm-banner__actions">
              <button
                className="alarm-banner__btn alarm-banner__btn--ack"
                onClick={() => onAcknowledge(alarm.id)}
                title={t('Acknowledge alarm')}
              >
                {t('Acknowledge')}
              </button>
              <button
                className="alarm-banner__btn alarm-banner__btn--view"
                onClick={() => {
                  onGoToAlarms();
                  onDismiss(alarm.id);
                }}
                title={t('View all alarms')}
              >
                {t('View')}
              </button>
              <button
                className="alarm-banner__btn alarm-banner__btn--dismiss"
                onClick={() => onDismiss(alarm.id)}
                title={t('Dismiss notification')}
              >
                x
              </button>
            </div>
          </div>
        );
      })}
    </div>
  );
}
